module.exports = __webpack_public_path__ + "img/album15_19.10ad28eb.jpg";